import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { colors } from '../../const/colors'

export const StepTitle: FC<{ n: string; title: string; sub: string }> = ({
  n,
  title,
  sub,
}) => (
  <>
    <Typography
      sx={{
        fontSize: '16.5px',
        fontWeight: 800,
        letterSpacing: '-0.01em',
        mb: '3px',
      }}
    >
      {n} · {title}
    </Typography>
    <Typography sx={{ fontSize: '13px', color: colors.textMuted, mb: '14px' }}>
      {sub}
    </Typography>
  </>
)

export const ErrorBanner: FC<{
  heading: string
  message: string
  sx?: object
}> = ({ heading, message, sx }) => (
  <Box
    role="alert"
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      p: '16px 18px',
      borderRadius: colors.radiusRow,
      background: colors.redBg,
      border: `2px solid ${colors.redBorder}`,
      borderLeft: `6px solid ${colors.red}`,
      boxShadow: '0 6px 18px rgba(192, 57, 43, 0.18)',
      ...sx,
    }}
  >
    <ErrorOutlineIcon sx={{ fontSize: 24, color: colors.red, mt: '-1px' }} />
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 800,
          letterSpacing: '0.01em',
          color: colors.redDark,
          mb: '3px',
        }}
      >
        {heading}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: 1.45,
          color: colors.red,
          wordBreak: 'break-word',
        }}
      >
        {message}
      </Typography>
    </Box>
  </Box>
)

export const SectionLabel: FC<{ children: string; sx?: object }> = ({
  children,
  sx,
}) => (
  <Typography
    sx={{
      fontSize: '11px',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: colors.slate,
      fontWeight: 700,
      mb: '10px',
      ...sx,
    }}
  >
    {children}
  </Typography>
)
